import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { AccessResult, hasAtLeastOneRequiredAction, NO_ACCESS_MESSAGE } from "utils/access";
import { Action } from "types/generated";

export const UPDATE_TEMPLATE_ACCESS_TYPES = [
  Action.SpaceAdmin,
  Action.UpdateBlueprintsVersionedGroup,
];

const useCanManageTemplate = (): ((spaceId?: string) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (spaceId?: string) => {
      if (!spaceId) {
        return { result: false };
      }

      if (viewer.admin) {
        return { result: true };
      }

      const result = hasAtLeastOneRequiredAction(UPDATE_TEMPLATE_ACCESS_TYPES, viewer, spaceId);

      if (result) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useCanManageTemplate;
